// TODO(WEB): Implement react-native-appearance shim
import React from 'react'
import { ColourScheme } from 'APP/Helpers/AppearanceUtils'

const Appearance = {
  getColorScheme() {
    return ColourScheme.LIGHT
  },
  addChangeListener() {
    return {
      remove: () => {},
    }
  },
}

export default Appearance

export const AppearanceProvider = ({ children }) => {
  return <>{children}</>
}
